import React, { memo } from 'react';
import { Pressable } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';

export const DataGridRow = memo(({ children, dataItem, index }) => {
  const { styles } = useStyle();
  var isOdd = index % 2 === 0;
  return (
    <Pressable
      style={({ hovered }) => [
        styles.headerContainer,
        isOdd && styles.oddContainer,
        hovered && styles.hoverContainer,
      ]}
      children={({ pressed, hovered, focused }) =>
        React.Children.map(children, (element) =>
          React.cloneElement(element, { dataItem, hovered })
        )
      }
    />
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  headerContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 64,
    padding: 16,
  },
  oddContainer: {
    backgroundColor: colors.blue2,
  },
  hoverContainer: {
    backgroundColor: colors.blue8,
  },
}));
